<!-- 我的页面 -->
<template>
  <div v-if="showSee">
    <div class="backmodal">
      <div class="backflex">
        <div class="b_content">
          <div class="box">
            <div class="title">尊享会员权益</div>
            <div class="pc">
              <div class="see-list">
                <div class="wrap" v-for="(item, index) in imgData" :key="index">
                  <img class="img" :src="index==4?'https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202212/d6b7f81fa8e5cd6b9a3d09673ab40400.png':item.src" />
                  <div class="txt">{{ item.text }}</div>
                </div>
              </div>
            </div>
            <div class="mobile">
              <div class="mobile see-list-mobile">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in imgData" :key="index">
                      <div class="group">
                        <img class="img" :src="index==4?'https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202212/d6b7f81fa8e5cd6b9a3d09673ab40400.png':item.src" />
                        <div class="txt">{{ item.text }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
              <div class="next" @click="next">next</div>
            </div>
          </div>
          <div class="b_close" @click="close">
            <img src="@/assets/image/icon/close.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import Swiper from "swiper";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      term1: true,
      mySwiper: null,
      term2: true,
      imgData: []
    };
  },
  props: {
    showSee: {
      type: Boolean,
      default: false
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadImg();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {
    this.swiperDraw();
  }, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    close() {
      this.$emit("close");
    },
    loadImg() {
      let url = this.$store.state.API.my.crmMemberRightBanner;
      let params = {};
      this.$http
        .get(url, params, {
          headers: {
            tb_token: window.localStorage.getItem("token"),
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.data.message == "success" && res.data.result) {
            this.imgData = res.data.returnData;
          }
        });
    },
    swiperDraw() {
      var mySwiper = new Swiper(".swiper-container", {
        // slidesPerView: 1,
        // spaceBetween: 30,
        // centeredSlides: true,
        pagination: {
          el: ".swiper-pagination"
        },
        paginationClickable: true,
        loop: true,
        navigation: {
          nextEl: ".btn2",
          prevEl: ".btn1"
        }
      });
      this.mySwiper = mySwiper;
    },
    next() {
      this.mySwiper.slideNext();
    },
    prev() {
      this.mySwiper.slidePrev();
    }
  }
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
.pc {
  display: block;
}
.mobile {
  display: none;
}
.backmodal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(104, 104, 104, 0.6);
  z-index: 999;
  .backflex {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .b_content {
      width: 123.2rem;
      padding: 3rem 2rem 2rem;
      background: #fff;
      position: relative;
      display: flex;
      justify-content: center;
      .box {
        width: 100%;
        text-align: center;
        .logo {
          width: 8.6rem;
          height: 3.8rem;
          margin-bottom: 2rem;
        }
        .title {
          text-align: center;
        }
        .see-list {
          display: flex;
          margin-top: 5rem;
          .wrap {
            width: 22.4rem;
            margin-right: 1.6rem;
            .img {
              width: 100%;
              object-fit: cover;
              height: 28rem;
            }
            .txt {
              text-align: center;
              margin-top: 1.6rem;
              font-size: 1.2rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5c5d5f;
            }
          }
          .wrap:last-child {
            margin-right: 0rem;
          }
        }
        .see-list-mobile {
          margin-top: 2.6rem;
          // overflow: hidden;

          .group {
            padding-bottom: 4rem;
            .img {
              width: 100%;
              object-fit: cover;
              height: 28rem;
            }
            .txt {
              text-align: center;
              margin-top: 1.6rem;
              font-size: 1.2rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5c5d5f;
            }
          }
        }
        .next {
          width: 100%;
          height: 4rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-family: ArialNarrow;
          color: #ffffff;
          margin-top: 2rem;
          background: #5c5d5f;
        }
        .swiper-container {
          position: relative;
          overflow: hidden;
        }
        .swiper-slide {
          text-align: center;
          transition: 300ms;
          transform: scale(0.8);
          .img_item {
            width: 100%;
            height: 100%;
          }
          .mask {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            background: #d8d8d8;
            opacity: 0.4;
          }
        }
        .swiper-slide-active,
        .swiper-slide-duplicate-active {
          transform: scale(1);
          .mask {
            display: none;
          }
        }
        .pagination {
          display: flex;
          justify-content: center;
          > img {
            cursor: pointer;
            width: 50px;
            height: 50px;
          }
          .title {
            margin: 0px 5vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 13px;
            font-family: ArialNarrow;
            color: #5c5d5f;
          }
        }
      }
      .b_close {
        cursor: pointer;
        width: 1.3rem;
        height: 1.3rem;
        position: absolute;
        top: 2.8rem;
        right: 2.8rem;
        img {
          width: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 1240px) {
  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }
  .backmodal .backflex .b_content {
    width: 34rem;
    // width: calc(100% - 4rem);
    .box {
      max-width: 30rem;
      .list {
        padding: 2rem 1rem;
        .item {
          padding: 1rem 0rem 0;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .backmodal .backflex .b_content {
    max-width: 30rem;
    // width: calc(100% - 4rem);
    .box {
      max-width: 30rem;
      .list {
        padding: 2rem 1rem;
        .item {
          padding: 1rem 0rem 0;
        }
      }
    }
  }
}
/deep/.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0.1rem;
}
/deep/.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 0.5rem;
}
/deep/.swiper-pagination-bullet {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #5c5d5f;
  opacity: 0.3;
}
/deep/.swiper-pagination-bullet-active {
  background-color: #5c5d5f;
  opacity: 1;
  margin: 0 0.5rem;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SeeMemberPop.vue